export const BLUE_1 = "#5E8EED";
export const BLUE_2 = "#2163BB";
export const BLUE_3 = "#1A5099";
export const BLUE_4 = "#003355";
export const GRAY_1 = "#222222";
export const GRAY_2 = "#111111";
export const GRAY_3 = "#333333";
export const GRAY_4 = "#444444";
export const GRAY_5 = "#666666";
export const GRAY_6 = "#999999";
export const GRAY_7 = "#F1F1F1";
export const GREEN_1 = "#00BB00";
export const GREEN_2 = "#099000";
export const GREEN_3 = "#207010";
export const PINK_1 = "#FF8080";
export const PINK_2 = "#DF5B5B";
export const RED_1 = "#E43030";
export const RED_2 = "#A02020";
export const RED_3 = "#501A1A";
export const YELLOW_1 = "#FFA111";
export const YELLOW_2 = "#D07D00";
export const YELLOW_3 = "#A05200";